import { useAgentHold, setGapHold, useToast } from '@elva/ui';

/** Holding Gap Filler (amendment 26 §2 → specs 36 + 37, shared store). */
export function useGapHold(): { onHold: boolean; setHold: (next: boolean) => void } {
  const hold = useAgentHold('gap-filler');
  const { toast } = useToast();
  return {
    onHold: hold.held,
    setHold: (next: boolean) => {
      setGapHold(next);
      toast({
        title: next ? 'Gap Filler is on hold' : 'Gap Filler is working again',
        variant: next ? 'warning' : 'success',
      });
    },
  };
}
